const messages = {
    availPoints: "Pontos disponíveis",
    awaitingPoints: "Pontos pendentes",
  board: {
    title: "Painel",
    title2: "Animação de desempenho {year}",
    headline1: "As suas promoções e pontos num relance",
    headline2: "Ganhe pontos pelas compras de pneus.",
    pointsBalanceToDate: "SALDO DE PONTOS ATÉ À DATA",
    availPoints: "Pontos disponíveis",
    awaitingPoints: "Pontos pendentes",
    yourRealisation: "SUAS REALIZAÇÕES",
    yourEngagement: "Seu compromisso anual: <b>pneus {tyres}</b>",
    yourPoints: "SEUS PONTOS",
    yourRetailPurchase: "SUAS COMPRAS NO VAREJO",
    yourRetailPurchaseCCS: "SUAS VENDAS NO VAREJO",
    pointsByPurchase: "pontos gerados por suas compras",
    pointsByBoosters: "pontos gerados por boosters",
    pointsByBSPurchase: "Pontos gerados pelas suas compras na Bridgestone",
    pointsByBSPurchaseCCS:
      "Pontos gerados pelas suas vendas de pneus Bridgestone",
    remaining: "Pneus restantes",
    yourGoal: "Progresso da meta",
    unit: "pneus",
    buttons: {
      learnMore: "Saiba mais sobre os seus pontos",
      learnMoreAboutMechanism: "Saiba mais sobre a mecânica",
    },
    charts: {
      byBrand: "Por marca",
      bySize: "Por tamanho<br/>da jante",
    },
    exploreResults: "Descubra seus resultados",
    tyreLimitInfo:
      "É necessário um volume mínimo de venda de 50 pneus Bridgestone e/ou Firestone para cada período da campanha Booster",
  },
  charts: {
    byBrand: "Por marca",
    bySize: "por tamanho do aro",
  },

  dashboard: {
    dashboardTitle: "Os seus benefícios",
    dashboardBox: {
      title: "Saldo de pontos",
      description: "Seu total atual de pontos de marketing",
      availPoints: "Pontos disponíveis",
      awaitingPoints: "Pontos pendentes",
      lastUpdate: "Última atualização",
      button: "Saber mais",
      points: "points",
    },
  },
  soldTyres: "PNEUS VENDIDOS",
  receivedPoints: "PONTOS GANHADOS",
  boosterCCS: {
    personalInfo: "Informações pessoais",
    csNumberTitle: "Especifique o(s) número(s) da conta participante",
    tyresTitle: "Especifique o número de pneus vendidos",
    minTyresInfo:
      "É necessário um mínimo de pneus {tyres} Bridgestone/Firestone. A compensação aplica-se apenas aos pneus Bridgestone.",
    tyresAmount: "Nº de pneus",
    filesTitle: "Por favor, carregue seu comprovante de vendas",
    filesDescription:
      "Observação: apenas serão consideradas vendas que especifiquem o tamanho do aro do pneu.",
    addAnotherFile: "Adicionar outro documento",
    file: "Carregar documento",
    formatInfo:
      "Formatos de arquivo aceitos: xlsx, jpeg e pdf. Tamanho máximo do arquivo: 8 MB",
    confrimationMessage:
      "<b>Obrigado pela sua participação!</b> <br/>O seu pedido foi recebido e encaminhado às equipas da Bridgestone para validação.<br/>Receberá uma notificação por e-mail com os resultados da sua participação no Booster CCS.<br/>Nos vemos em breve no Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Compartilhe pontos",
    forShare: "Pontos que você compartilhará",
    title: "Título",
  },
  notFoundFile: "Nenhum selecionado",
  chooseFile: "Escolha o arquivo",
};
export default {
  messages,
};
